const state = {
    courtName: '',    //法院名称
    token: '',
    username: '', //工作人名称
    jobNumber: '',//工号
    window: '',//窗口名称
    service: '',//服务业务
    queueno: ''//业务队列号
}

export default state